exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.main[data-v-1810ed42] {\n  overflow: auto;\n  max-width: 10rem;\n}\n", ""]);

// exports
